/**
 * @date: 12/28/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */

import React from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import './Label.css';


export default function MaxMDLabel(props) {
    const color = props.color || "default";
    const renderHtml = props.renderHtml || null;
    const value = props.value || ""
    const noIcon = props.noIcon || false;
    const full = props.full || false


    var cls = "";
    if (color === "succ" || color === "success") {
        cls = "label-success";
    } else if (color === "err" || color === "error"){
        cls = "label-error";
    } else if (color === "info"){
        cls = "label-info";
    } else if (color === "warning"){
        cls = "label-warning";
    } else {
        cls = "";
    }
    if (full){
        cls = cls + " label-full";
    }


    let inner;
    if (renderHtml){
        inner = renderHtml();
    } else if (value){
        inner = <> {value} </>
    } else {
        inner = "";
    }

    return (<div className={`label ${cls}`}>
        { (color === "succ" || color === "success") && !noIcon && <CheckCircleIcon />}
        {inner}
    </div>);
}
